import state from './moduleChurnReasonsState';
import getters from './moduleChurnReasonsGetters';
import mutations from './moduleChurnReasonsMutations';
import actions from './moduleChurnReasonsActions';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};


